<script>

export default {
  name: 'ImageGallery',
  components: {},
  props: {
    context: {
      type: Object
    }
  },

  data() {
    return {
      index: null
    }
  },

  render( e ) {
    const _self = this;

    if(_self.context.properties.data && _self.context.properties.data.medias){

      _self.context.properties.data.medias.forEach((oneMedia) => {
        oneMedia.description = oneMedia.alt;
      });

    }

    const render = {
      data(){
        return {
          index: _self.index,
          data: _self.context.properties.data
        }
      },
      template: _self.context.properties.template
    }
    return  e( render );
  }
}
</script>
<style>

.gallery-wrapper .thumb-wrapper .image {
  cursor: pointer;
  border-radius: 0.3rem;
  width: 100%;
}

</style>